import { tns } from 'tiny-slider/src/tiny-slider'

// Hero slider
export function initSlider (name) {
	const element = document.querySelector('[data-slider="' + name + '"]')
	const prev = document.querySelector('[data-slider-prev="' + name + '"]')
	const next = document.querySelector('[data-slider-next="' + name + '"]')
	const counter = document.querySelector('[data-slider-counter="' + name + '"]')

	// don't start function if the element is not on the page
	if (!element) return

	const slider = tns({
		container: element,
		items: 1,
		loop: false,
		mouseDrag: true,
		autoplay: false,
		autoplayTimeout: 7500,
		autoHeight: true,
		controls: true,
		lazyLoad: false,
		nav: false,
		autoplayButtonOutput: false,
		prevButton: prev,
		nextButton: next
	})

	slider.events.on('indexChanged', function (info, eventName) {
		console.log(info, eventName)

		counter.innerText = info.displayIndex + ' / ' + info.slideCount
	})

	return slider
}

// Small slider
export function initSmallSlider (name) {
	const element = document.querySelector('[data-slider="' + name + '"]')
	// don't start function if the element is not on the page
	if (!element) return

	const slider = tns({
		container: element,
		items: 1,
		loop: false,
		mouseDrag: true,
		autoplay: false,
		autoplayTimeout: 7500,
		autoHeight: false,
		controls: false,
		lazyLoad: true,
		nav: false,
		autoplayButtonOutput: false
	})

	return slider
}

// Content slider
export function initContentSlider (name) {
	const element = document.querySelector('[data-slider="' + name + '"]')
	// don't start function if the element is not on the page
	if (!element) return

	const slider = tns({
		container: element,
		items: 1,
		loop: false,
		mouseDrag: true,
		autoplay: false,
		autoplayTimeout: 7500,
		autoHeight: true,
		controls: false,
		lazyLoad: true,
		nav: true,
		navPosition: 'bottom',
		autoplayButtonOutput: false
	})

	return slider
}